import React from "react";
import { GlobalStyles, Theme, ThemeProvider } from "@mui/material";

import { setIn } from "fond/utils";

const AUTOFILL_KEYFRAMES = {
  "@keyframes mui-auto-fill": { from: { display: "block" } },
  "@keyframes mui-auto-fill-cancel": { from: { display: "block" } },
};

const withSharedInputGlobalStyles = (outerTheme: Theme): Theme =>
  setIn(outerTheme, ["components", "MuiInputBase", "defaultProps", "disableInjectingGlobalStyles"], true);

interface IProps {
  children: React.ReactNode;
}

/**
 * Disable injecting global styles for MUI TextField's autofill keyframes within `children`, injecting them once instead.
 *
 * MUI TextField's inject their own styles for autofill keyframes. If we're rendering a lot
 * of TextField's (e.g. in the BOM tab of the architecture modal), then each TextField injects
 * its own keyframes which is a known performance hazard, see e.g.
 * https://mui.com/material-ui/react-text-field/#performance
 */
const SharedInputGlobalStyles: React.FC<IProps> = ({ children }: IProps) => (
  <ThemeProvider theme={withSharedInputGlobalStyles}>
    <GlobalStyles styles={AUTOFILL_KEYFRAMES} />
    {children}
  </ThemeProvider>
);

export default SharedInputGlobalStyles;
